/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Export_Error_Equipments_RangeInputs */



/**
* | output |
* | --- |
* | "Min must be less than or equal to Max" |
*
* @param {Intervention_Plan_Export_Error_Equipments_RangeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_export_error_equipments_range = /** @type {((inputs?: Intervention_Plan_Export_Error_Equipments_RangeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Export_Error_Equipments_RangeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Min must be less than or equal to Max")
	return /** @type {LocalizedString} */ ("Min doit être inferieur ou égale à Max")
});